<template>
	<div class="CountryFilterWrapper">
		<ul class="RefineContentOptionsList">
			<li v-for="item in countryFilterOptions"
				:key="item.optionValue"
			>
				<CountryCheckbox
					:optionName="item.optionName"
					:optionValue="item.optionValue"
					:hasAreas="item.hasAreas"
					v-bind:class="{ Indented: !item.hasAreas}"
				/>
				
				<Areas v-if="item.hasAreas"
					:countryId="item.optionValue"
					@areaFilterChange="processAreaFilterChange"
				/>
			</li>
		</ul>
		<button type="button" class="AddCountry" v-if="!showMultiselect" @click="displayMultiselect">
			<i class="lnr-plus"></i> Add
		</button>

		<MultiSelect
			v-if="showMultiselect"
			:options="transformedCountryFormat"
			track-by="label"
			label=""
			placeholder="Add country"
			:searchable=true
			select-label=""
			:allow-empty="true"
			openDirection="below"
			aria-label="Select a country"
			@updated="onSelect"
		/>
	</div>
</template>

<script lang="ts" src="./CountryFilter.ts"></script>
<style lang="scss" scoped src="./CountryFilter.scss"></style>
